import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { TipoFreteSelectModule, TipoFretePipeModule } from '../../../../common/tipo-frete';
import { TransportadoraSharedModule } from '../../../transportadora/transportadora-shared.module';
import { ClienteLogisticaFormComponent } from './cliente-logistica-form.component';

@NgModule({
  imports: [
    SharedModule,
    TipoFreteSelectModule,
    TipoFretePipeModule,
    TransportadoraSharedModule
  ],
  declarations: [
    ClienteLogisticaFormComponent
  ],
  exports: [
    ClienteLogisticaFormComponent
  ]
})
export class ClienteLogisticaFormModule {}
